import Jar from "@/components/visual/Jar";
import { isStockImage } from "@/lib/productImage";

/**
 * Thumb: shows an uploaded image, or a clean placeholder when there is no
 * image or only a stock photo. kind="product" draws the jar; any other
 * kind draws a quiet typographic tile with the label.
 */
export default function Thumb({ src, alt = "", kind = "product", label, className = "", imgClassName = "w-full h-full object-cover" }) {
  if (src && !isStockImage(src)) {
    return <img src={src} alt={alt} loading="lazy" className={imgClassName} />;
  }
  if (kind === "product") {
    return (
      <div className={`w-full h-full bg-brand-obsidian flex items-center justify-center ${className}`} role="img" aria-label={alt}>
        <Jar className="h-[80%] w-auto" label={false} title={alt} />
      </div>
    );
  }
  return (
    <div className={`w-full h-full bg-brand-parchment-soft flex items-end p-5 ${className}`} role="img" aria-label={alt}>
      <span className="font-display text-[20px] leading-tight tracking-[-0.02em] text-brand-ink/80 line-clamp-3">{label || alt}</span>
    </div>
  );
}
